import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DialogInfoData = {
  header: string;
  body: string;
  buttonText?: string;
  onClose?: (e: Event) => void;
};

@Component({
  selector: 'app-dialog-info',
  templateUrl: './dialog-info.component.html',
  styleUrl: './dialog-info.component.scss',
  standalone: false,
})
export class DialogInfoComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogInfoComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: DialogInfoData
  ) {}

  close = (e: Event) => {
    if (this.data.onClose) this.data.onClose(e);
    this.dialogRef.close();
  };
}

